import dayjs from 'lib/dayjs'

export enum DateFormat {
  DEFAULT = 'YYYY-MM-DD',
  DEFAULT_WITH_TIME = 'YYYY-MM-DD HH:mm:ss',
}

const formatDate = (date?: Date | null) =>
  date ? dayjs(date).format(DateFormat.DEFAULT) : ''

export default formatDate
